<template>
  <draggable
    :list="internalItems"
    :handle="handle"
    :item-key="itemKey"
    data-sb-regression="sb-draggable"
    easing="cubic-bezier(1, 0, 0, 1)"
    @start="dragStart"
    @end="dragEnd"
  >
    <template #item="{ element, index }">
      <div class="draggable-item">
        <!-- Slot in which the draggable element is rendered -->
        <slot
          name="sb-drag-item"
          :element="element"
          :index="index"
        />
      </div>
    </template>
  </draggable>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import draggable from 'vuedraggable';

export default {
  name: 'SbDraggable',
  components: {
    draggable,
  },
  props: {
    /**
    * Array of items which are to be rearranged
    */
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
    /**
    * CSS classname of the handler, default is to make the entire element draggable
    */
    handle: {
      type: String,
      default: '',
    },
    /**
    * Unique key identifying each item
    */
    itemKey: {
      type: String,
      default: '',
    },
  },
  emits: [
    /**
    * Emitted when a drag event starts
    */
    'drag-start',
    /**
    * Emitted when a drag event is completed
    */
    'drag-end',
  ],
  data() {
    return {
      internalItems: cloneDeep(this.items),
    };
  },
  watch: {
    items: {
      handler(newItems) {
        this.internalItems = cloneDeep(newItems);
      },
      deep: true,
    },
  },
  methods: {
    dragStart(e) {
      this.$emit('drag-start', {
        event: e,
      });
    },
    dragEnd(e) {
      this.$emit('drag-end', {
        event: e,
        data: this.internalItems,
      });
    },
  },
};
</script>

<style lang='scss'>
.draggable-item {
  margin: 0.5em 0;
}
</style>
